import React from 'react'
import { CommonStyle } from '../styles/common-styles'
import CarouselItem from '../components/UI-layout/carousal-item';
import UseWindowSize from '../hooks/helpers/useWindowSize';
import ScrollContainer from 'react-indiana-drag-scroll';
import leftImage from '../public/images/left-img.png';
import rightImage from '../public/images/right-img.png';
import Head from 'next/head';
import { customerReviews } from '../utils/wordings';
import Link from 'next/link';
import { DownloadAppFooter } from '../components/download-app-footer';
import { CustomerReviewsComponent } from '../components/customer-reviews';
import Image from 'next/image';

function Dealership() {
    const screenProps = UseWindowSize();

    return (
        <div className="container-fluid p-0">
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care Dealership - Explore Quality Vehicles and Exceptional Services" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/dealership.html" hrefLang="en" />
            </Head>
            <CommonStyle>
                <div className="bg-white">
                    <div className="wireframe-bg d-flex justify-content-center align-items-center" style={{ height: 450 }}>
                        <div className="text-center">
                            <div className='mx-2'>
                                <h1 className="heavy-bold dark-text mx-md-auto">The Way You Care For<br className='d-none d-md-block' /> Your Car Has Changed</h1>
                                <h3 className="grey-text mt-4 fw-normal mx-md-auto">
                                    Gone are the days of getting your car maintained by<br className='d-none d-md-block' /> dealerships and shady shops. Welcome to a fully transparent<br className='d-none d-md-block' /> car care experience. You’ll never go back to a dealership again.
                                </h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className='dealer-grid'>
                        <div className='left-section mb-5 mb-lg-0'>
                            <div className="col-lg-10 my-4 my-lg-0 text-center " style={screenProps?.windowSize?.width > 920 ? { float: 'right' } : {}}>
                                <Image src={leftImage.src} className="img-fluid " width={710} height={550} alt='top-banner' loading='lazy'  style={{borderRadius: 10}} />
                            </div>

                            <div className='col-lg-8 mt-5' style={screenProps?.windowSize?.width > 920 ? { float: 'right' } : {}}>
                                <p className='text-lg-right heading'>Paleo Car Care</p>
                                <div className='grid-section'>
                                    <p className='title'>Clear Pricing</p>
                                    <p className='description'> We want to solve the problem of pricing by being completely clear and transparent in all our pricing so you know you’re getting the best deal.</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>No Quotas</p>
                                    <p className='description'>{` We're here to serve you, not a middle man who sets a quota on repairs. We make our decisions based only on what you need.`}</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>Full Service Experience</p>
                                    <p className='description'> We pioneered the idea of modern car care where you should get all the services you need for your vehicle. From gas delivery to state inspections.</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>Membership Savings</p>
                                    <p className='description'>{`With our membership model we’re able to pass on the savings to you and cover many services that you never thought would be available.`}</p>
                                </div>
                            </div>
                        </div>
                        <div className='right-section'>
                            <div className="col-lg-10 my-4 my-lg-0 text-center" style={screenProps?.windowSize?.width > 920 ? { float: 'left', clear: 'both' } : {}}>
                                <Image src={rightImage.src} className="img-fluid " alt='top-banner' loading='lazy' width={710} height={550} style={{borderRadius: 10}} />
                            </div>

                            <div className='col-lg-8 mt-5' style={{ float: 'left' }}>
                                <p className='heading'>Other Dealerships</p>
                                <div className='grid-section'>
                                    <p className='title'>Biased Pricing</p>
                                    <p className='description'>Inconsistent and biased pricing is what makes car shops infamous. Whenever you get your estimate you never know if you’re being taken for a ride.</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>Quotas Influence Recommentations</p>
                                    <p className='description'>When a shop or dealership has quotas that they need to meet that sadly might lead to them recommending a service that you don’t actually need.</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>Limited Services</p>
                                    <p className='description'>Other shops are only able to do the repairs on your car. But they leave out the other valuable services that make your life easier and prevent issues.</p>
                                </div>
                                <div className='grid-section'>
                                    <p className='title'>Expensive, large bills</p>
                                    <p className='description'> Discounts and free services seemed like an impossibility in the past. The only model others do are large bills due when you least expect them.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CustomerReviewsComponent title={"Car Dealerships Don’t Get Reviews Like This"}/>
                <DownloadAppFooter/>

            </CommonStyle>
        </div>
    )
}

export default Dealership